/** Anzeige-Label für Dateityp anhand Extension. */
export function formatFileTypeLabel(ext = "") {
  const e = String(ext || "")
    .toLowerCase()
    .replace(/^\./, "");
  const map = {
    pdf: "PDF",
    png: "Bild (PNG)",
    jpg: "Bild (JPEG)",
    jpeg: "Bild (JPEG)",
    gif: "Bild (GIF)",
    webp: "Bild (WebP)",
    txt: "Textdatei",
    csv: "CSV",
    json: "JSON",
    xml: "XML",
    log: "Logdatei",
    eml: "E-Mail (EML)",
    emlx: "E-Mail (EMLX)",
    msg: "E-Mail (MSG)",
    xls: "Excel",
    xlsx: "Excel",
    doc: "Word",
    docx: "Word",
    ppt: "PowerPoint",
    pptx: "PowerPoint",
    zip: "ZIP-Archiv",
    rar: "RAR-Archiv",
    "7z": "7-Zip-Archiv",
  };
  return map[e] || (e ? e.toUpperCase() : "Datei");
}

/** Bytes → lesbare Grösse (UI). */
export function formatDisplayFileSize(bytes) {
  const n = Number(bytes);
  if (!Number.isFinite(n) || n <= 0) return "";
  if (n >= 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(2)} MB`;
  return `${Math.max(1, Math.round(n / 1024))} KB`;
}
